// extracted by mini-css-extract-plugin
export default {"mainWrapper":"EachVisitWrapper_mainWrapper__1q73r","mainContainer":"EachVisitWrapper_mainContainer__b1OgU"};